import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { StarRating } from '@liveauctioneers/hammer-ui-core/starRating';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo } from 'react';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';

type Props = {
    rating: number;
};

const RatingDisplayComponent = ({ rating }: Props) => {
    const isMobile = useIsMobileLayout();

    return rating >= 0 ? (
        <div
            className={cn(
                'flex',
                isMobile ? 'mt-0 flex-col items-start justify-center' : 'mt-sm flex-row items-center justify-start'
            )}
            data-testid="symbolRatings"
        >
            <StarRating
                averageRating={rating}
                className={cn({ 'mr-sm': !isMobile })}
                emphasis="bold"
            />
            {rating > 0 && rating <= 5 && (
                <BodySecondary
                    className={cn({ 'mt-xs': isMobile })}
                    color="secondary"
                >
                    <FormattedMessage id={`review_page.review_copy._${rating}`} />
                </BodySecondary>
            )}
        </div>
    ) : (
        <div>
            <BodySecondary color="secondary">N/A</BodySecondary>
        </div>
    );
};

export const RatingDisplay = memo<Props>(RatingDisplayComponent);
